module.exports = __webpack_public_path__ + "img/074668561c474f4b3a1be1ea38841838.png";